const STORAGE_KEY = 'vizaAzCookieConsent';
const CONSENT_VERSION = 1;

/**
 * Saxlanmış razılığı oxuyur. Brauzer yaddaşı bağlı olduqda (gizli pəncərə,
 * bloklanmış sayt datası) oxuma xəta verir, ona görə həmişə try/catch içindədir.
 */
const readConsent = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);

    return parsed && parsed.version === CONSENT_VERSION ? parsed : null;
  } catch (error) {
    return null;
  }
};

const writeConsent = (consent) => {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...consent, version: CONSENT_VERSION, date: new Date().toISOString() })
    );
  } catch (error) {
    // Yaddaş əlçatmazdırsa seçim yalnız bu sessiya üçün qüvvədə qalır.
  }
};

/**
 * Razılığı saytın qalan hissəsinə elan edir ki, analitika kimi alətlər
 * yalnız icazə verildikdə işə düşsün.
 */
const publishConsent = (consent) => {
  window.vizaAzCookieConsent = consent;
  document.documentElement.dataset.cookieConsent = consent.analytics ? 'full' : 'necessary';
  document.dispatchEvent(new CustomEvent('viza-az:cookie-consent', { detail: consent }));
};

export default function initCookieNotice() {
  const notice = document.querySelector('[data-cookie-notice]');

  if (!notice) {
    return;
  }

  const options = notice.querySelector('[data-cookie-options]');
  const settingsButton = notice.querySelector('[data-cookie-settings]');
  const saveButton = notice.querySelector('[data-cookie-save]');
  const acceptButton = notice.querySelector('[data-cookie-accept-all]');
  const rejectButton = notice.querySelector('[data-cookie-reject]');
  const checkboxes = Array.from(notice.querySelectorAll('[data-cookie-category]'));

  const stored = readConsent();

  if (stored) {
    publishConsent(stored);

    return;
  }

  if (options) {
    options.id = 'cookie-notice-options';
  }

  notice.hidden = false;
  // Açılış animasiyası yalnız element görünən kimi başlasın.
  window.requestAnimationFrame(() => notice.classList.add('is-visible'));

  const close = (consent) => {
    publishConsent(consent);
    writeConsent(consent);
    notice.classList.remove('is-visible');

    const hide = () => {
      notice.hidden = true;
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      hide();

      return;
    }

    notice.addEventListener('transitionend', hide, { once: true });
    // Keçid baş tutmasa belə element gizlənsin.
    window.setTimeout(hide, 500);
  };

  if (acceptButton) {
    acceptButton.addEventListener('click', () => close({ functional: true, analytics: true }));
  }

  if (rejectButton) {
    rejectButton.addEventListener('click', () => close({ functional: false, analytics: false }));
  }

  if (settingsButton && options) {
    settingsButton.addEventListener('click', () => {
      const open = options.hidden;

      options.hidden = !open;
      settingsButton.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (saveButton) {
        saveButton.hidden = !open;
      }

      if (open) {
        const first = options.querySelector('[data-cookie-category]');

        if (first) {
          first.focus();
        }
      }
    });
  }

  if (saveButton) {
    saveButton.addEventListener('click', () => {
      const consent = { functional: false, analytics: false };

      checkboxes.forEach((box) => {
        const category = box.dataset.cookieCategory;

        if (category in consent) {
          consent[category] = box.checked;
        }
      });

      close(consent);
    });
  }
}
